/**
 * Indian mobile: 10 digits starting 6–9.
 * Accepts optional +91 / 91 / 0 prefix and spaces/dashes.
 */
export function normalizePhone(raw: string): string | null {
  const digits = (raw || "").replace(/\D/g, "");
  if (!digits) return null;

  let ten = digits;
  if (digits.length === 12 && digits.startsWith("91")) {
    ten = digits.slice(2);
  } else if (digits.length === 11 && digits.startsWith("0")) {
    ten = digits.slice(1);
  } else if (digits.length !== 10) {
    return null;
  }

  if (!/^[6-9]\d{9}$/.test(ten)) return null;
  return ten;
}

export function isValidPhone(raw: string): boolean {
  return normalizePhone(raw) !== null;
}
